import { useEffect } from 'react';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';
import useFeature from './useFeature';

const OFF_VARIANT_KEY = 'off';

type UseFeatureExposureOptions = {
  enabled?: boolean;
};

const useFeatureExposure = (
  flagKey: string,
  { enabled = true }: UseFeatureExposureOptions = {},
) => {
  const { source, variationKey, isLoading } = useFeature(flagKey);
  const { trackEventOnce } = useAnalytics();

  useEffect(() => {
    if (!enabled || isLoading || source !== 'amplitude') return;
    if (!variationKey || variationKey === OFF_VARIANT_KEY) return;

    trackEventOnce('$exposure', `${flagKey}:${variationKey}`, {
      flag_key: flagKey,
      variant: variationKey,
    });
  }, [enabled, flagKey, isLoading, source, trackEventOnce, variationKey]);
};

export default useFeatureExposure;
